<template>
	<div class="legend-container py-3 px-5 rounded-4 bg-neutral-25 border-xs">
		<h3 class="text-neutral-900 text-title-s">{{ $t('common.legend') }}</h3>
		<div class="d-flex flex-row gap-2 pt-2">
			<div
				v-for="item in legend_items"
				:key="'legend-item-' + item.text.toLowerCase()"
				class="d-flex align-center"
			>
				<div class="legend-item-color-dot rounded-full" :class="item.color" />
				<p class="ml-1 text-neutral-900 text-body-m">{{ item.text }}</p>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
	const { t } = useI18n()

	const legend_items = [
		{
			text: t('common.action.visited'),
			color: 'bg-primary-500',
		},
		{
			text: t('common.action.wishlist'),
			color: 'bg-secondary-500',
		},
	]
</script>
<style scoped lang="scss">
	.legend-container {
		backdrop-filter: blur(40px);
		background: #f6f6f64d;
		border-color: #ffffff33;
	}
	.legend-item-color-dot {
		width: 12px;
		height: 12px;
	}
</style>
